import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const BeamsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const beams = [
    { x: '10%', delay: 0 },
    { x: '30%', delay: 0.5 },
    { x: '50%', delay: 1 },
    { x: '70%', delay: 1.5 },
    { x: '90%', delay: 2 },
  ]
  const beamWidth = 100

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {/* Vertical beams */}
      {beams.map((beam, beamIndex) => (
        <motion.div
          key={beamIndex}
          style={{
            position: 'absolute',
            top: 0,
            left: beam.x,
            width: `${0.25 * (beamWidth / 100)}rem`,
            height: '100%',
            background: `linear-gradient(to bottom, transparent, ${effectColors[beamIndex % effectColors.length]}, transparent)`,
          }}
          animate={{
            opacity: [0.2 * opacityValue, opacityValue, 0.2 * opacityValue],
            scaleY: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 3 * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
            delay: beam.delay,
          }}
        />
      ))}

      {/* Horizontal sweeping beam */}
      <motion.div
        style={{
          position: 'absolute',
          left: 0,
          width: '100%',
          height: `${0.0625 * (beamWidth / 100)}rem`,
          background: `linear-gradient(to right, transparent, ${effectColors[0]}, transparent)`,
        }}
        animate={{
          top: ['0%', '100%'],
          opacity: [0, opacityValue, 0],
        }}
        transition={{
          duration: 4 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'linear',
        }}
      />
    </div>
  )
})
BeamsEffect.displayName = 'BeamsEffect'
